"use client";

import { ContentfulLivePreviewProvider } from "@contentful/live-preview/react";

export function ContentfulProvider({
  children,
  draftModeEnabled,
}: {
  children: React.ReactNode;
  draftModeEnabled: boolean;
}) {
  return (
    <ContentfulLivePreviewProvider
      locale="en-US"
      enableInspectorMode={draftModeEnabled}
      enableLiveUpdates={draftModeEnabled}
      debugMode={draftModeEnabled && process.env.NODE_ENV !== "production"}
    >
      {children}
    </ContentfulLivePreviewProvider>
  );
}
